// Access Permissions
export const ACCESS_PERMISSIONS = {
  DASHBOARD: 'access.dashboard',
} as const;

// Fulfilment Overview Permissions
export const FULFILMENT_OVERVIEW_PERMISSIONS = {
  OVERVIEW: 'fulfilment.overview',
} as const;

// Fulfilment Order Permissions
export const FULFILMENT_ORDER_PERMISSIONS = {
  INDEX: 'fulfilmentOrder.index',
  STORE: 'fulfilmentOrder.store',
  PARAMS: 'fulfilmentOrder.params',
  SKIP_ADDRESS_VALIDATION: 'fulfilmentOrder.skipAddressValidation',
  UPDATE: 'fulfilmentOrder.update',
  SHOW: 'fulfilmentOrder.show',
  IMPORT: 'fulfilmentOrder.import',
  EXPORT: 'fulfilmentOrder.export',
  BULK_UPDATE: 'fulfilmentOrder.bulkUpdate',
  IMPORT_SERIALNUMBERS: 'fulfilmentOrder.importSerialnumbers',
} as const;

// Fulfilment Shipment Permissions
export const FULFILMENT_SHIPMENT_PERMISSIONS = {
  INDEX: 'fulfilmentShipment.index',
  SHOW: 'fulfilmentShipment.show',
  EXPORT: 'fulfilmentShipment.export',
} as const;

// Fulfilment Parcel Permissions
export const FULFILMENT_PARCEL_PERMISSIONS = {
  INDEX: 'fulfilmentParcel.index',
  SHOW: 'fulfilmentParcel.show',
  EXPORT: 'fulfilmentParcel.export',
} as const;

// Fulfilment Return Permissions
export const FULFILMENT_RETURN_PERMISSIONS = {
  INDEX: 'fulfilmentReturn.index',
  SHOW: 'fulfilmentReturn.show',
  EXPORT: 'fulfilmentReturn.export',
  UPDATE: 'fulfilmentReturn.update',
} as const;

// Fulfilment Product Permissions
export const FULFILMENT_PRODUCT_PERMISSIONS = {
  INDEX: 'fulfilmentProduct.index',
  SHOW: 'fulfilmentProduct.show',
  STORE: 'fulfilmentProduct.store',
  UPDATE: 'fulfilmentProduct.update',
  BUNDLE: 'fulfilmentProduct.bundle',
  EXPORT: 'fulfilmentProduct.export',
  IMPORT: 'fulfilmentProduct.import',
  BULK_UPDATE: 'fulfilmentProduct.bulkUpdate',
  PROPERTY_INDEX: 'fulfilmentProduct.property.index',
} as const;

// Fulfilment Stock (Inventory) Permissions
export const FULFILMENT_STOCK_PERMISSIONS = {
  INDEX: 'fulfilmentStock.index',
  SHOW: 'fulfilmentStock.show',
  EXPORT: 'fulfilmentStock.export',
  HISTORY: 'fulfilmentStock.history',
} as const;

// Fulfilment Purchase Order Permissions
export const FULFILMENT_PURCHASE_ORDER_PERMISSIONS = {
  INDEX: 'fulfilmentPurchaseOrder.index',
  SHOW: 'fulfilmentPurchaseOrder.show',
  STORE: 'fulfilmentPurchaseOrder.store',
  UPDATE: 'fulfilmentPurchaseOrder.update',
  RELEASE: 'fulfilmentPurchaseOrder.release',
  EXPORT: 'fulfilmentPurchaseOrder.export',
  IMPORT: 'fulfilmentPurchaseOrder.import',
  SLOT_BOOKING: 'fulfilmentPurchaseOrder.slotBooking',
} as const;

// Shop Owner Permissions
export const SHOP_OWNER_PERMISSIONS = {
  INDEX: 'shopOwner.index',
  SHOW: 'shopOwner.show',
  SUPPLIER_INDEX: 'shopOwner.supplier.index',
  WAREHOUSE_INDEX: 'shopOwner.warehouse.index',
} as const;

// Shop Group Permissions
export const SHOP_GROUP_PERMISSIONS = {
  INDEX: 'shopGroup.index',
  SHOW: 'shopGroup.show',
} as const;

// Shop Permissions
export const SHOP_PERMISSIONS = {
  INDEX: 'shop.index',
  SHOW: 'shop.show',
  UPDATE: 'shop.update',
  PAYMENT_TYPE_INDEX: 'shop.paymentTypes.index',
  VAT_INDEX: 'shop.vats.index',
  ORDER_PROCESSING: 'shop.orderProcessing',
} as const;

// Currency Permissions
export const CURRENCY_PERMISSIONS = {
  INDEX: 'currency.index',
} as const;

// Carrier Permissions
export const CARRIER_PERMISSIONS = {
  INDEX: 'carrier.index',
} as const;

// Import Permissions
export const IMPORT_PERMISSIONS = {
  INDEX: 'import.index',
  SHOW: 'import.show',
  LINE_INDEX: 'import.line.index',
} as const;

// User Invite Permissions
export const USER_INVITE_PERMISSIONS = {
  INDEX: 'user.invite.index',
  SHOW: 'user.invite.show',
} as const;

// Language Permissions
export const LANGUAGE_PERMISSIONS = {
  INDEX: 'language.index',
} as const;

// Report Permissions
export const REPORT_PERMISSIONS = {
  SHOW: 'report.show',
  EXPORT: 'report.export',
  GET_KPI_DATA: 'report.getKpiData',
  GET_NEW: 'report.getNew',
  CUSTOMER_CARE_EVENTS: 'report.customerCareEvents',
  FULFILLMENT_EVENTS: 'report.fulfillmentEvents',
  FULFILLMENT_RETURNS: 'report.fulfillmentReturns',
  FULFILLMENT_PARCELS: 'report.fulfillmentParcels',
} as const;

export const TICKET_PERMISSIONS = {
  INDEX: 'ticket.index',
  SHOW: 'ticket.show',
  STORE: 'ticket.store',
  UPDATE: 'ticket.update',
} as const;

export const TICKET_TOPIC_PERMISSIONS = {
  INDEX: 'ticket.topic.index',
} as const;

export const USER_NOTIFICATION_PERMISSIONS = {
  DESTROY: 'user.notification.destroy',
} as const;

// Main PERMISSIONS object
export const PERMISSIONS = {
  ACCESS: ACCESS_PERMISSIONS,
  FULFILMENT_OVERVIEW: FULFILMENT_OVERVIEW_PERMISSIONS,
  FULFILMENT_ORDER: FULFILMENT_ORDER_PERMISSIONS,
  FULFILMENT_SHIPMENT: FULFILMENT_SHIPMENT_PERMISSIONS,
  FULFILMENT_PARCEL: FULFILMENT_PARCEL_PERMISSIONS,
  FULFILMENT_RETURN: FULFILMENT_RETURN_PERMISSIONS,
  FULFILMENT_PRODUCT: FULFILMENT_PRODUCT_PERMISSIONS,
  FULFILMENT_STOCK: FULFILMENT_STOCK_PERMISSIONS,
  FULFILMENT_PURCHASE_ORDER: FULFILMENT_PURCHASE_ORDER_PERMISSIONS,
  SHOP_OWNER: SHOP_OWNER_PERMISSIONS,
  SHOP_GROUP: SHOP_GROUP_PERMISSIONS,
  SHOP: SHOP_PERMISSIONS,
  CURRENCY: CURRENCY_PERMISSIONS,
  CARRIER: CARRIER_PERMISSIONS,
  IMPORT: IMPORT_PERMISSIONS,
  USER_INVITE: USER_INVITE_PERMISSIONS,
  LANGUAGE: LANGUAGE_PERMISSIONS,
  REPORT: REPORT_PERMISSIONS,
  TICKET: TICKET_PERMISSIONS,
  TICKET_TOPIC: TICKET_TOPIC_PERMISSIONS,
  USER_NOTIFICATION: USER_NOTIFICATION_PERMISSIONS,
} as const;

// Type definitions for autocomplete
export type AccessPermission =
  (typeof ACCESS_PERMISSIONS)[keyof typeof ACCESS_PERMISSIONS];
export type FulfilmentOverviewPermission =
  (typeof FULFILMENT_OVERVIEW_PERMISSIONS)[keyof typeof FULFILMENT_OVERVIEW_PERMISSIONS];
export type FulfilmentOrderPermission =
  (typeof FULFILMENT_ORDER_PERMISSIONS)[keyof typeof FULFILMENT_ORDER_PERMISSIONS];
export type FulfilmentShipmentPermission =
  (typeof FULFILMENT_SHIPMENT_PERMISSIONS)[keyof typeof FULFILMENT_SHIPMENT_PERMISSIONS];
export type FulfilmentParcelPermission =
  (typeof FULFILMENT_PARCEL_PERMISSIONS)[keyof typeof FULFILMENT_PARCEL_PERMISSIONS];
export type FulfilmentReturnPermission =
  (typeof FULFILMENT_RETURN_PERMISSIONS)[keyof typeof FULFILMENT_RETURN_PERMISSIONS];
export type FulfilmentProductPermission =
  (typeof FULFILMENT_PRODUCT_PERMISSIONS)[keyof typeof FULFILMENT_PRODUCT_PERMISSIONS];
export type FulfilmentStockPermission =
  (typeof FULFILMENT_STOCK_PERMISSIONS)[keyof typeof FULFILMENT_STOCK_PERMISSIONS];
export type FulfilmentPurchaseOrderPermission =
  (typeof FULFILMENT_PURCHASE_ORDER_PERMISSIONS)[keyof typeof FULFILMENT_PURCHASE_ORDER_PERMISSIONS];
export type ShopOwnerPermission =
  (typeof SHOP_OWNER_PERMISSIONS)[keyof typeof SHOP_OWNER_PERMISSIONS];
export type ShopGroupPermission =
  (typeof SHOP_GROUP_PERMISSIONS)[keyof typeof SHOP_GROUP_PERMISSIONS];
export type ShopPermission =
  (typeof SHOP_PERMISSIONS)[keyof typeof SHOP_PERMISSIONS];
export type CurrencyPermission =
  (typeof CURRENCY_PERMISSIONS)[keyof typeof CURRENCY_PERMISSIONS];
export type CarrierPermission =
  (typeof CARRIER_PERMISSIONS)[keyof typeof CARRIER_PERMISSIONS];
export type ImportPermission =
  (typeof IMPORT_PERMISSIONS)[keyof typeof IMPORT_PERMISSIONS];
export type UserInvitePermission =
  (typeof USER_INVITE_PERMISSIONS)[keyof typeof USER_INVITE_PERMISSIONS];
export type LanguagePermission =
  (typeof LANGUAGE_PERMISSIONS)[keyof typeof LANGUAGE_PERMISSIONS];
export type ReportPermission =
  (typeof REPORT_PERMISSIONS)[keyof typeof REPORT_PERMISSIONS];
export type TicketPermission =
  (typeof TICKET_PERMISSIONS)[keyof typeof TICKET_PERMISSIONS];
export type TicketTopicPermission =
  (typeof TICKET_TOPIC_PERMISSIONS)[keyof typeof TICKET_TOPIC_PERMISSIONS];

export type Permission =
  | AccessPermission
  | FulfilmentOverviewPermission
  | FulfilmentOrderPermission
  | FulfilmentShipmentPermission
  | FulfilmentParcelPermission
  | FulfilmentReturnPermission
  | FulfilmentProductPermission
  | FulfilmentStockPermission
  | FulfilmentPurchaseOrderPermission
  | ShopOwnerPermission
  | ShopGroupPermission
  | ShopPermission
  | CurrencyPermission
  | CarrierPermission
  | ImportPermission
  | UserInvitePermission
  | LanguagePermission
  | ReportPermission
  | TicketPermission
  | TicketTopicPermission;
